<div class="rightComp action-plan-page" [dir]="isArabic ? 'rtl' : 'ltr'">
  <div class="col-12 action-item-container" *ngIf="!this.actionItems || this.actionItems.length === 0"
    [ngStyle]="{'text-align': isArabic ? 'right' : 'left'}">
    <ng-container *ngIf="!isArabic">Nothing to see here!! No appeal is pending</ng-container>
    <ng-container *ngIf="isArabic">لا يوجد ما يمكن عرضه حالياً! لا توجد أي طلبات تظلم قيد الانتظار</ng-container>
  </div>

  <div class="col-12 action-item-container" *ngIf="this.actionItems && this.actionItems.length > 0">
    <div class="action-item-section-header mb-3" [ngClass]="isArabic ? 'flex-row-reverse' : 'flex-row'">
      <div>
        <div *ngIf="!isArabic">
          <span class="header-font">Assessment Name:</span>
          <span class="font-radikal-light"> {{ assessmentName || '-' }}</span>
        </div>
        <div *ngIf="isArabic" style="text-align: right;">
          <span class="header-font">:اسم التقييم</span>
          <span class="font-radikal-light"> {{ assessmentName || '-' }}</span>
        </div>

        <div *ngIf="!isArabic" class="mt-1">
          <span class="header-font">Inspection:</span>
          <span class="font-radikal-light"> {{ inspection || '-' }}</span>
        </div>
        <div *ngIf="isArabic" style="text-align: right;">
          <span class="header-font">:التفتيش</span>
          <span class="font-radikal-light"> {{ inspection || '-' }}</span>
        </div>
      </div>
    </div>

    <div class="select-title" [style.text-align]="isArabic ? 'right' : 'left'">
      <ng-container *ngIf="!isArabic">Select action to appeal</ng-container>
      <ng-container *ngIf="isArabic">اختر إجراءً للتظلّم</ng-container>
    </div>

    <div class="fine-cards">
      <div class="customTable fine-card" *ngFor="let item of actionItems; let i = index"
        [dir]="isArabic ? 'rtl' : 'ltr'">
        <label class="card-checkbox" style="float: none;">
          <input type="checkbox" [checked]="item.selected" (change)="toggleSelect(item, $event)" />
        </label>

        <div class="action-item-header" [ngClass]="isArabic ? 'flex-row-reverse' : 'flex-row'"
          style="justify-content: flex-start;">
          <div class="index-circle" [style.margin-right.px]="isArabic ? 0 : 8"
            [style.margin-left.px]="isArabic ? 8 : 0">
            <span><b>{{ i + 1 }}</b></span>
          </div>
          <div class="action-item-title" [style.text-align]="isArabic ? 'right' : 'left'">
            <span *ngIf="!isArabic">{{ item.appealTitle }}</span>
            <span *ngIf="isArabic">عنصر الإجراء</span>
          </div>
        </div>

        <div class="ai-pair" [style.text-align]="isArabic ? 'right' : 'left'">
          <div class="ai-key">
            <ng-container *ngIf="!isArabic">Action Item:</ng-container>
            <ng-container *ngIf="isArabic">عنصر الإجراء:</ng-container>
          </div>
          <div class="ai-val">{{ item.title || '-' }}</div>
        </div>

        <div class="ai-pair" [style.text-align]="isArabic ? 'right' : 'left'">
          <div class="ai-key">
            <ng-container *ngIf="!isArabic">Violation</ng-container>
            <ng-container *ngIf="isArabic">المخالفة</ng-container>
          </div>
          <div class="ai-val font-radikal-light">{{ item.violation || '-' }}</div>
        </div>

        <div class="ai-pair" [style.text-align]="isArabic ? 'right' : 'left'">
          <div class="ai-key">
            <ng-container *ngIf="!isArabic">Clause Number:</ng-container>
            <ng-container *ngIf="isArabic">رقم البند:</ng-container>
          </div>
          <div class="ai-val">{{ item.clauseNumber || "-" }}</div>
        </div>

        <div class="fine-grid" [style.justify-content]="isArabic ? 'flex-end' : 'flex-start'">
          <div class="fine-field" [style.text-align]="isArabic ? 'right' : 'left'">
            <label>
              <ng-container *ngIf="!isArabic">Fine Amount</ng-container>
              <ng-container *ngIf="isArabic">قيمة الغرامة</ng-container>
            </label>
            <input class="form-control" type="text" [value]="item.fine | number:'1.2-2'" readonly
              dir="{{ isArabic ? 'rtl' : 'ltr' }}" />
          </div>

          <!-- Attach Documents Section -->
          <div class="fine-field" [attr.id]="'attachmentsection_'+i" class="collapse mw-50p"
            [style.text-align]="isArabic ? 'right' : 'left'">
            <label>
              <ng-container *ngIf="!isArabic">Attach the supporting Documents</ng-container>
              <ng-container *ngIf="isArabic">إرفاق المستندات الداعمة</ng-container>
            </label>
            <div class="file-wrap" [dir]="isArabic ? 'rtl' : 'ltr'">
              <label class="upload-btn" [attr.for]="'file-input-' + i" [style.text-align]="isArabic ? 'right' : 'left'">
                <div class="upload-left">
                  <div class="upload-placeholder">
                    <ng-container *ngIf="item.documentName; else defaultText">
                      <div class="doc-name">{{ item.documentName }}</div>
                      <div class="small-note" [style.text-align]="isArabic ? 'right' : 'left'">
                        <ng-container *ngIf="!isArabic">Click to attach</ng-container>
                        <ng-container *ngIf="isArabic">انقر للإرفاق</ng-container>
                      </div>
                    </ng-container>
                    <ng-template #defaultText>
                      <div class="upload-text" [style.text-align]="isArabic ? 'right' : 'left'">
                        <ng-container *ngIf="!isArabic">Upload Documents</ng-container>
                        <ng-container *ngIf="isArabic">تحميل المستندات</ng-container>
                      </div>
                    </ng-template>
                  </div>
                </div>
                <div class="upload-right" aria-hidden="true" [style.float]="isArabic ? 'left' : 'right'">
                  <!-- svg icon -->
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12 3v10" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <path d="M8 7l4-4 4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                    <rect x="3" y="13" width="18" height="8" rx="2" stroke="currentColor" stroke-width="1.2"
                      fill="none" />
                  </svg>
                </div>
              </label>
              <input id="{{'file-input-' + i}}" type="file" name="{{'files-' + i}}" (change)="onFileChange($event, i)"
                multiple class="visually-hidden-file-input" />
            </div>
            <div *ngFor="let f of item.files; let fi = index" class="file-row"
              [style.text-align]="isArabic ? 'right' : 'left'">
              <span>{{ fi + 1 }}. {{ f.name }}</span>
              <label>
                <img src="../../../assets/images/delete.png" alt="Delete" class="del-icon"
                  (click)="onDeleteNewFile(i, fi)" />
              </label>
            </div>
            <div class="muted-note" [style.text-align]="isArabic ? 'right' : 'left'">
              {{ item.files?.length ?? 0 }} <ng-container *ngIf="!isArabic">file{{ (item.files?.length ?? 0) === 1 ? ''
                : 's' }} selected</ng-container><ng-container *ngIf="isArabic">ملف{{ (item.files?.length ?? 0) === 1 ?
                '' : 'ات' }} تم تحديد</ng-container>
            </div>

            <div *ngIf="item.selected && fetchedDocuments && fetchedDocuments.length > 0" class="document-section mt-3"
              [style.text-align]="isArabic ? 'right' : 'left'">
              <button class="p-0 d-flex align-items-center docshow" (click)="toggleDocuments()"
                [ngClass]="isArabic ? 'flex-row-reverse' : 'flex-row'">
                <h6 class="mb-0 me-2">
                  <ng-container *ngIf="!isArabic">Attached Documents ({{fetchedDocuments.length}})</ng-container>
                  <ng-container *ngIf="isArabic">المستندات المرفقة ({{fetchedDocuments.length}})</ng-container>
                </h6>
                <span class="toggle-icon">
                  <svg *ngIf="!showDocuments" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 5v14M5 12h14" />
                  </svg>
                  <svg *ngIf="showDocuments" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14" />
                  </svg>
                </span>
              </button>
              <div *ngIf="showDocuments" class="mt-2" [style.text-align]="isArabic ? 'right' : 'left'">
                <div *ngFor="let document of fetchedDocuments; let i = index" class="d-flex align-items-baseline"
                  [ngClass]="isArabic ? 'flex-row-reverse' : 'flex-row'">
                  <span class="document-index me-2">{{ i + 1 }}.</span>
                  <span class="document-name">{{ document.filename }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- buttons for comments / upload toggle -->
        <div *ngIf="!appealHistorical" class="plan-buttons-container mt-3 d-flex" [ngStyle]="{
    'flex-direction': isArabic ? 'row-reverse' : 'row',
    'justify-content': isArabic ? 'flex-end' : 'flex-start'
  }">
          <button type="button" class="plan-button" data-bs-toggle="collapse"
            [attr.data-bs-target]="'#commentsbox_' + i" aria-expanded="false">
            <ng-container *ngIf="!isArabic">Comment</ng-container>
            <ng-container *ngIf="isArabic">تعليق</ng-container>
          </button>

          <button type="button" class="plan-button" data-bs-toggle="collapse"
            [attr.data-bs-target]="'#attachmentsection_' + i" aria-expanded="false">
            <ng-container *ngIf="!isArabic">Upload</ng-container>
            <ng-container *ngIf="isArabic">رفع</ng-container>
          </button>
        </div>

        <div class="upload-overlay"></div>
        <div id="uploadPopup" class="upload-popup" [style.text-align]="isArabic ? 'right' : 'left'">
          <p *ngIf="!isArabic">Uploading files, please wait...</p>
          <p *ngIf="isArabic">يتم الآن تحميل الملفات، يُرجى الانتظار.</p>
          <progress id="uploadProgressBar" value="0" max="100" style="width: 100%; height: 20px;"></progress>
          <p id="progressPercent">{{uploadProgress}}%</p>
        </div>

        <!-- Comment history -->
        <div>
          <details [ngClass]="isArabic ? 'pull-right' : 'pull-left'" [style.text-align]="isArabic ? 'right' : 'left'">
            <summary>
              <ng-container *ngIf="!isArabic">Comment History</ng-container>
              <ng-container *ngIf="isArabic">سجل التعليقات</ng-container>
            </summary>
            <div style="white-space: pre-wrap; font-family: monospace; direction: {{isArabic ? 'rtl' : 'ltr'}};">
              {{ sanitizeComment(item.commentHistory) }}
            </div>
          </details>
        </div>

        <!-- comment textarea -->
        <textarea class="form-control comment w-70 collapse" [placeholder]="!isArabic ? 'Enter here' : 'أدخل هنا'"
          [attr.id]="'commentsbox_'+i" (input)="onCommentChange($event, i)" (keyup)="onKeyup($event, i)"
          [disabled]="appealHistorical" [style.text-align]="isArabic ? 'right' : 'left'"
          dir="{{ isArabic ? 'rtl' : 'ltr' }}">{{ item?.comments || '' }}</textarea>
      </div>
    </div>
  </div>

  <!-- Appeal form -->
  <div class="appeal-form mt-4" [style.text-align]="isArabic ? 'right' : 'left'">
    <div>
      <ng-container *ngIf="!isArabic">Appeal Form</ng-container>
      <ng-container *ngIf="isArabic">نموذج التظلّم</ng-container>
    </div>

    <ul class="appeal-tabs p-0" [ngClass]="isArabic ? 'flex-row-reverse text-right' : 'flex-row text-left'"
      [style.justifyContent]="isArabic ? 'flex-end' : 'flex-start'">
      <li type="button" class="tab" *ngFor="let t of appealTabs; let idx = index"
        [class.active]="activeAppealTab === idx" [class.font-radikal-light]="activeAppealTab != idx"
        (click)="activeAppealTab = idx" [style.textAlign]="isArabic ? 'right' : 'left'">

        >
        {{ t }}
      </li>
    </ul>

    <div class="appeal-tab-content" [dir]="isArabic ? 'rtl' : 'ltr'">
      <!-- GUIDELINES -->
      <div *ngIf="activeAppealTab === 0" class="tab-panel" [style.text-align]="isArabic ? 'right' : 'left'">
        <div class="guidelines">
          <h3>
            <ng-container *ngIf="!isArabic">Appeal grace Period</ng-container>
            <ng-container *ngIf="isArabic">مهلة تقديم التظلّم</ng-container>
          </h3>
          <ul>
            <li>
              <ng-container *ngIf="!isArabic">
                Client has <strong>30 Calendar days</strong> starting from the date of receiving the UBO Violation
                Decision
                from DIEZA to appeal and ensure providing the signed form, that must be properly filled by selecting
                the exact warning client is appealing against it (1st, 2nd or/and 3rd) with the amount. Only information
                on this signed form will be considered.
              </ng-container>
              <ng-container *ngIf="isArabic">
                يحق للمتعامل تقديم تظلم خلال <strong>30 يوماً تقويمياً</strong> تبدأ من تاريخ استلام قرار مخالفة
                المستفيد الحقيقي الصادر
                عن سلطة دبي للمناطق الاقتصادية المتكاملة. ويجب تقديم النموذج بعد تعبئته حسب الأصول وتوقيعه، مع
                تحديد الإنذار محل التظلم بدقة، سواء كان الإنذار الأول أو الثاني أو الثالث، أو أكثر من إنذار، مع بيان
                مبلغ الغرامة المرتبط به. ولن يُعتد إلا بالمعلومات الواردة في هذا النموذج الموقّع.
              </ng-container>
            </li>
            <li>
              <ng-container *ngIf="!isArabic">Evidence including the pre-notification inspection email and warnings,
                must be attached.</ng-container>
              <ng-container *ngIf="isArabic">يجب إرفاق الأدلة والمستندات الداعمة، بما في ذلك رسالة البريد الإلكتروني
                الخاصة بالإخطار المسبق بالتفتيش والإنذارات الصادرة.</ng-container>
            </li>
            <li>
              <ng-container *ngIf="!isArabic">For additional information requested by the authority, client has to
                revert back within the mentioned deadline.</ng-container>
              <ng-container *ngIf="isArabic">في حال طلبت السلطة أي معلومات إضافية، يجب على المتعامل تقديمها خلال المهلة
                المحددة في الطلب.</ng-container>
            </li>
            <li>
              <ng-container *ngIf="!isArabic">Reply post any of the above-mentioned deadline will lead to an
                auto-rejection of appeal request.</ng-container>
              <ng-container *ngIf="isArabic">يؤدي الرد أو تقديم المستندات بعد انقضاء أي من المهل المذكورة أعلاه إلى رفض
                طلب التظلم تلقائياً.</ng-container>
            </li>
          </ul>

          <h3>
            <ng-container *ngIf="!isArabic">Appeal procedure</ng-container>
            <ng-container *ngIf="isArabic">إجراءات تقديم التظلّم</ng-container>
          </h3>
          <ul>
            <li>
              <ng-container *ngIf="!isArabic">
                The authorized person has to send an email attaching this form signed with evidence to:
                <a href="mailto:aml@diez.ae">aml@diez.ae</a>. Subject: UBO Violation - Appeal request-License number.
              </ng-container>
              <ng-container *ngIf="isArabic">
                يجب على الشخص المفوض إرسال رسالة بريد إلكتروني مرفقاً بها هذا النموذج بعد توقيعه، إلى جانب الأدلة
                والمستندات الداعمة، إلى:
                <a href="mailto:aml@diez.ae">aml@diez.ae</a>. عنوان الرسالة: مخالفة المستفيد الحقيقي – طلب تظلم – رقم
                الرخصة.
              </ng-container>
            </li>
            <li>
              <ng-container *ngIf="!isArabic">An acknowledgement to be received within 5 working days requesting for
                additional information or stating the fulfillment of the requirements.</ng-container>
              <ng-container *ngIf="isArabic">سيتم إرسال إشعار باستلام الطلب خلال خمسة أيام عمل، يتضمن طلب تقديم معلومات
                إضافية، إن وجدت، أو تأكيد استيفاء المتطلبات.</ng-container>
            </li>
            <li>
              <ng-container *ngIf="!isArabic">Client will receive the appeal request' status by the concerned team
                within <strong>45 days from receiving the acknowledgement email</strong>.</ng-container>
              <ng-container *ngIf="isArabic">سيتم إخطار المتعامل بحالة طلب التظلم من قبل الفريق المختص خلال 45 يوماً من
                تاريخ استلام رسالة تأكيد استلام الطلب.</ng-container>
            </li>
            <li>
              <ng-container *ngIf="!isArabic">Note: follow up emails by clients within the mentioned period are not to
                be considered.</ng-container>
              <ng-container *ngIf="isArabic">ملاحظة: لن يتم النظر في رسائل المتابعة المرسلة من المتعامل خلال المدة
                المذكورة أعلاه.</ng-container>
            </li>
          </ul>

          <h3>
            <ng-container *ngIf="!isArabic">Document Required</ng-container>
            <ng-container *ngIf="isArabic">المستندات المطلوبة</ng-container>
          </h3>

          <ul>
            <li>
              <ng-container *ngIf="!isArabic">Company license</ng-container>
              <ng-container *ngIf="isArabic">الرخصة التجارية للمنشأة</ng-container>
            </li>
            <li>
              <ng-container *ngIf="!isArabic">Evidence to support the mentioned statement/argument.</ng-container>
              <ng-container *ngIf="isArabic">الأدلة والمستندات المؤيدة للبيانات أو الدفوع الواردة في طلب
                التظلم.</ng-container>
            </li>
            <li>
              <ng-container *ngIf="!isArabic">Identity of the person submitting the appeal case, that must be the
                authorized person to represent the company.</ng-container>
              <ng-container *ngIf="isArabic">مستند إثبات هوية مقدم طلب التظلم، على أن يكون الشخص المفوض قانوناً بتمثيل
                المنشأة.</ng-container>
            </li>
          </ul>

          <p>
            <ng-container *ngIf="!isArabic">References:</ng-container>
            <ng-container *ngIf="isArabic">المراجع:</ng-container>
          </p>

          <ul>
            <li>
              <ng-container *ngIf="!isArabic">Anti-Money Laundering Crimes Legislations | Ministry of Economy -
                UAE</ng-container>
              <ng-container *ngIf="isArabic">تشريعات مواجهة جرائم غسل الأموال | وزارة الاقتصاد والسياحة – الإمارات
                العربية المتحدة</ng-container>
            </li>
          </ul>
        </div>
      </div>

      <!-- ENTITY DETAILS, APPELLANT DETAILS, APPEAL DETAILS, AUTHORIZED PERSON tabs... -->
      <!-- Add similar direction and text-align styles for all inputs, labels, and containers as above -->

    </div>

    <div class="form-actions mt-3" [ngClass]="isArabic ? 'flex-row-reverse' : 'flex-row'"
      style="justify-content: space-between;">
      <button class="btn back" type="button" (click)="onBack()" [disabled]="activeAppealTab === 0">
        <ng-container *ngIf="!isArabic">Back</ng-container>
        <ng-container *ngIf="isArabic">رجوع</ng-container>
      </button>

      <button class="btn next" type="button" (click)="onNext()" *ngIf="activeAppealTab < appealTabs.length - 1">
        <ng-container *ngIf="!isArabic">Next</ng-container>
        <ng-container *ngIf="isArabic">التالي</ng-container>
      </button>
    </div>

    <div *ngIf="formError" class="alert alert-danger" role="alert" style="margin-top: 15px;"
      [style.text-align]="isArabic ? 'right' : 'left'">
      {{ formError }}
    </div>

    <button class="btn-lg btn-primary ratButton rightBtn nextButton mt-3" type="button" (click)="initiateAppeal()"
      *ngIf="!appealHistorical && activeAppealTab === appealTabs.length - 1"
      [disabled]="isUnderReview || isSubmitDisabled()"
      [title]="isUnderReview ? (isArabic ? 'التقييم قيد المراجعة' : 'Assessment Under Review') : ''">
      <ng-container *ngIf="!isArabic">{{appealSubmitButtonEn}}</ng-container>
      <ng-container *ngIf="isArabic">بدء الاستئناف</ng-container>
    </button>

  </div>
</div>